// extracted by mini-css-extract-plugin
export default {"box":"menulist_box__Z+pL7","badge":"menulist_badge__Ylj1y"};